import React, { useState, useEffect, useCallback } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import Form from "react-bootstrap/Form";
import {
  Col,
  Modal,
  Tooltip,
  OverlayTrigger,
  Nav,
  Dropdown,
} from "react-bootstrap";
import { getCode, getName } from "country-list";

import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { City, Country, State } from "country-state-city";
import {
  addSupplier,
  masterListSupplier,
} from "../../../service/Suppliers/SuppliersService";
import { getAllCurrencylist } from "../../../service/Currency/CurrencyService";
import { searchUnspc } from "../../../service/Segment/SegmentService";
import { getAllCurrencyData } from "../../../service/Currency/CurrencyService";
import {
  getAllProductDetailslist,
  getInvoiceSupplierList,
  // getSegmentList,
  getUnspcAdd,
  getActiveProduct,
  getFamilyList,
  getClassList,
  getCommodityUnspcList,
  updateBaseQty,
} from "../../../service/Product/ProductService";
import {
  deleteSegment,
  getAddSegment,
  getAddSegmentToAll,
  getSegmentAdd,
  getSegmentList,
  getSegmentUnspcAdd,
  getFamilyUnspcAdd,
  getClassUnspcAdd,
} from "../../../service/Segment/SegmentService";
import { toast } from "react-toastify";
import CustomSelect from "./CustomSelect";
import MyMultiSelect from "./MyMultiSelect";
import SpinnerComponent from "../../components/SpinnerComponent";
import { useTranslation } from "react-i18next";
import useUnitData from "../products/UnitData";
import { getAllGHGlist } from "../../../service/ghg/ghgService";
import { debounce } from "lodash";

const TreeItem = ({ title, children, onClick, isOpen, toggleOpen }) => {
  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ display: "flex", margin: "5px" }}>
        <div
          onClick={toggleOpen}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {!title.startsWith("Commodity Code") && (
            <span style={{ marginRight: "5px" }}>{isOpen ? "−" : "+"}</span>
          )}
          {title}
        </div>
        {/* {<ConditionalContent />} */}

        {/* {!title.startsWith("Segment Code") && (
          <div>
            <Button
              variant="success"
              style={{
                height: "24px",
                padding: "1px 2px",
                marginLeft: "5px",
              }}
            >
              GL Key
            </Button>
          </div>
        )} */}
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};

const Addsuppliers = () => {
  const { t } = useTranslation();
  const unitData = useUnitData();
  const [existingOrNew, setExistingOrNew] = useState("existing");
  const [currency, setCurrency] = useState([]);
  const navigate = useNavigate();
  //COUNTRY-STATE-CITY
  let countryData = Country.getAllCountries().map((item) => ({
    name: item?.name,
    countryCode: item?.isoCode,
  }));
  const [stateData, setStateData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [showUnspc, setShowUnspc] = useState(false);
  const [selected, setSelected] = useState([]);
  const [segmentCode, setSegmentCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fullCountryData, setFullCountryData] = useState();
  const [fullStateData, setFullStateData] = useState();

  const [images, setImages] = useState([]);
  const [saleUnit, setSaleUnit] = useState([]);
  const [baseUnit, setBaseUnit] = useState([]);
  const [subUnit, setSubUnit] = useState([]);
  const [co2Unit, setCo2Unit] = useState([]);
  const [saleChecked, setSaleChecked] = useState(false);
  const [baseChecked, setBaseChecked] = useState(false);
  const [subChecked, setSubChecked] = useState(false);
  const [co2Checked, setCo2Checked] = useState(false);
  const [ghgData, setGhgData] = useState("");

  const [openSegment, setOpenSegment] = useState(null);
  const [openFamily, setOpenFamily] = useState(null);
  const [openClass, setOpenClass] = useState(null);

  const handleSegmentClick = (segment) => {
    setOpenSegment(openSegment === segment ? null : segment);
    if (onDataSegment) onDataSegment(segment);
  };

  const handleFamilyClick = (segment, family) => {
    setOpenFamily(openFamily === family ? null : family);
    setOpenClass(null); // Close all classes when a new family is opened
    if (onDataFamily) onDataFamily(family);
  };

  const handleClassClick = (family, classItem) => {
    setOpenClass(openClass === classItem ? null : classItem);
    if (onDataClass) onDataClass(classItem);
  };

  // Function to convert the array of objects
  function convertToArrayOfObjects(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      result.push({
        value: {
          code: array[index].Segment.Segment,
          point: "Segment",
          title: array[index].Segment.SegmentTitle,
          id: array[index].Segment.id,
        },
        label: `${array[index].Segment.SegmentTitle} ( Segment - ${array[index].Segment.Segment})`,
      });
      result.push({
        value: {
          code: array[index].Family.Family,
          point: "Family",
          title: array[index].Family.FamilyTitle,
          id: array[index].Family.id,
        },
        label: `${array[index].Family.FamilyTitle} ( Family - ${array[index].Family.Family})`,
      });
      result.push({
        value: {
          code: array[index].Class.Class,
          point: "Class",
          title: array[index].Class.ClassTitle,
          id: array[index].Class.id,
        },
        label: `${array[index].Class.ClassTitle} ( Class - ${array[index].Class.Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity.Commodity,
          point: "Commodity",
          title: array[index].Commodity.CommodityTitle,
          id: array[index].Commodity.id,
        },
        label: `${array[index].Commodity.CommodityTitle} ( Commodity - ${array[index].Commodity.Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(result.map(JSON.stringify));
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // console.log(uniqueArray,"res1")
    setSearchOptions(uniqueArray.filter((item) => item.value !== null));
    setIsLoading(false);
    // return uniqueArray;
  }

  const _SEARCH_UNSPSC = debounce((data) => {
    // console.log(e,"search Data")
    setIsLoading(true);
    searchUnspc(data, (res) => {
      convertToArrayOfObjects(res.data);
      // console.log(res.data,"resData")
      // console.log(convertToArrayOfObjects(res.data),'search data')
      // const flattenedData = Object.assign({}, ...res.data.map(item => item));
      // console.log(flattenedData,"flattenedData");
    });
    // console.log(e.target.value,"searchData")
  }, 500);

  const handleFileChange = (e) => {
    const selectedFiles = e.target.files;

    // Convert FileList to an array and update state
    setImages((prevImages) => [...prevImages, ...Array.from(selectedFiles)]);
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => {
      const newImages = [...prevImages];
      newImages.splice(index, 1);
      return newImages;
    });
  };

  const uploadImages = () => {
    // Implement your upload logic here, e.g., send images to a server
    // console.log(images);
  };

  // const [file, setFile] = useState();
  // function handleChange(e) {
  //     console.log(e.target.files);
  //     setFile(URL.createObjectURL(e.target.files[0]));
  // }

  const [myArrayUser, setMyArrayUser] = useState([]);
  const [userList, setAllUserList] = useState([]);
  const [userById, setUserById] = useState("");
  const [userById2, setUserById2] = useState("");
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [getDataSegment, setDataSegment] = useState("");
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);
  const [getDataFamily, setDataFamily] = useState("");
  const [familyList, setFamilyList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);
  const [segmentData, setSegmentData] = useState({});
  const [familyData, setFamilyData] = useState({});
  const [classData, setClassData] = useState({});
  const [commodityData, setCommodityData] = useState({});
  const [searchOptions, setSearchOptions] = useState([]);
  const [selectedUNSPSCData, setSelectedUNSPSCData] = useState({});
  const [listSearchSupplier, setListSearchSupplier] = useState([]);
  const [adminSupplierData, setAdminSupplierData] = useState({});
  const [ghgList, setGhgList] = useState([]);

  const units = unitData?.map((item, index) => ({
    value: item.common_unit,
    label: item.common_unit,
  }));

  const onSaleUnit = (data) => {
    setSaleUnit(data);
  };
  const onBaseUnit = (data) => {
    setBaseUnit(data);
  };
  const onSubUnit = (data) => {
    setSubUnit(data);
  };
  const onCO2Unit = (data) => {
    setCo2Unit(data);
  };

  const [isToggleddata, setToggleddata] = useState(true);

  const handleToggledata = () => {
    setToggleddata(!isToggleddata);
  };

  const onCountry = (val) => {
    const selectedIsoCode = val;
    // console.log("Country Selected:", val);

    // Find the country object based on the selected isoCode
    const selectedCountry = countryData.find(
      (country) => country.countryCode === selectedIsoCode
    );

    // Update the country name and set state data
    setCountry(selectedIsoCode);
    setFullCountryData(selectedCountry);

    const allStates = State.getStatesOfCountry(selectedIsoCode).map((item) => ({
      name: item?.name,
      isoCode: item?.isoCode,
    }));
    // console.log("All States:", allStates);
    setStateData(allStates);
  };

  const onState = (val) => {
    // console.log("State Selected:", val);
    const selectedIsoCode = val;
    setState(selectedIsoCode);

    let selectedState;
    if (stateData.length !== 0) {
      // console.log("ifffff");
      selectedState = stateData.find(
        (state) => state.isoCode === selectedIsoCode
      );
    } else {
      selectedState = State.getStatesOfCountry(
        JSON.parse(localStorage.getItem("gs3_User"))?.countryCode
      ).find((state) => state.isoCode === selectedIsoCode);
    }
    // console.log("selectedSatte", selectedState);
    setFullStateData(selectedState);

    const cities = City.getCitiesOfState(
      country || JSON.parse(localStorage.getItem("gs3_User"))?.countryCode,
      selectedIsoCode
    );
    setCityData(cities);
  };

  // console.log(State.getStatesOfCountry('IN'),"state")

  const onCity = (e) => {
    setCity(e.target.value);
  };

  // console.log(City.getCitiesOfState('IN','WB'))
  const _ON_SUBMIT = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let jsonForm = {};
    const formEl = document.getElementById("form-Data");

    const formData = new FormData(formEl);
    // formData.append('country',country);
    // formData.append('city',city);
    // formData.append('state',state);
    for (var pair of formData.entries()) {
      // console.log(pair[0]+ ', ' + pair[1]);
      jsonForm[pair[0]] = pair[1];
    }
    jsonForm.country = country;
    jsonForm.countryCode = fullCountryData?.countryCode;
    jsonForm.city = city;
    jsonForm.state = state;
    jsonForm.stateCode = fullStateData?.isoCode;

    jsonForm.unspscCode = selectedUNSPSCData?.value?.code;
    jsonForm.name = adminSupplierData?.name;
    jsonForm.MasterGHGId = JSON.parse(ghgData)?.id;
    // console.log("jsonForm", jsonForm);
    if (adminSupplierData?.supplierCompanyId) {
      addSupplier(jsonForm, (res) => {
        setIsLoading(false);
        if (res?.status === 200) {
          toast.success(res.message);
        } else {
          toast.error(res.message);
        }
        navigate("/suppliers");
      });
    } else {
      setIsLoading(false);
      toast.error("Supplier Company Id is required");
    }
  };

  const _FETCH_CURRENCY = async () => {
    getAllCurrencylist()
      .then((res) => {
        setCurrency(res.data.data.currencyList);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const _FETCH_LIST_CURRENCY = () => {
    setIsLoading(true);
    getAllCurrencyData()
      .then((res) => {
        setCurrency(res.data.data.availablecurrencyList);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        // console.log(err);
      });
  };

  useEffect(() => {
    _FETCH_LIST_CURRENCY();
    // _FETCH_CURRENCY();
    _SEARCH_SUPPLIER();
    getGHGDataList();
    getSegmentAddList();
  }, []);
  async function getSegmentAddList() {
    getSegmentList().then(function (result) {
      const response = result.data;
      setAllSegmentDataList(response?.data?.segmentList);
    });
  }

  async function getGHGDataList() {
    setIsLoading(true);
    getAllGHGlist().then(function (result) {
      const response = result?.data;
      setGhgList(response?.data?.ghgList);
      setIsLoading(false);
    });
  }

  const sortedData = ghgList.sort((a, b) => {
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    return 0;
  });

  const searchPage = () => {
    navigate("/search-all-unspsc");
  };

  const handleCloseUnspc = () => {
    setFamilyList([]);
    setClassList([]);
    setCommodityList([]);
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
  };

  const _SELECT_UNSPSC = (data) => {
    setIsLoading(true);
    setSelectedUNSPSCData(data);
    setShowUnspc(false);
    setAdminSupplierData({ ...adminSupplierData, unspscCode: data.value.code });
    setIsLoading(false);
    // getUnspcAdd(
    //   data,
    //   selected,
    //   (r) => {
    //     if (r.success === true) {
    //       toast.success(r.message);
    //       setShowUnspc(false);
    //       setSegmentCode("");

    //     } else {
    //       toast.error(r.message);
    //     }
    //   }
    // );
  };

  const onDataSegment = (e) => {
    setDataSegment(e);
    getSegmentUnspcAdd(e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcFamily(r?.data?.listUnspsc);

        // toast.success(r.message)
      } else {
        toast.error(r.message);
      }
    });
  };

  const onDataFamily = (e) => {
    setDataFamily(e);

    getFamilyUnspcAdd(getDataSegment, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcClass(r?.data?.listUnspsc);

        // toast.success(r.message)
      } else {
        toast.error(r.message);
      }
    });
  };

  const onDataClass = (e) => {
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getClassUnspcAdd(getDataSegment, getDataFamily, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcComodity(r?.data?.listUnspsc);

        // toast.success(r.message)
      } else {
        toast.error(r.message);
      }
    });
  };

  const onUnspc = (e, data = "") => {
    e.preventDefault();

    setShowUnspc(true);
    // if (data) {
    //   setSelected([data]);
    // }
  };

  const _SET_EMAIL = (e) => {
    e.preventDefault();
    document.getElementById("email").value = JSON.parse(
      localStorage.getItem("gs3_User")
    ).email;
  };

  const _SEARCH_SUPPLIER = (searchKeyword = "") => {
    setIsLoading(true);
    masterListSupplier(searchKeyword, (res) => {
      setListSearchSupplier(
        res.data.listSupplier.map((item) => {
          return {
            value: JSON.stringify({
              ...item,
              state: item.state ? item.state : "",
              country: item.country ? item.country : "",
              city: item.city ? item.city : "",
            }),
            label: item.name,
          };
        })
      );
      setIsLoading(false);
    });
  };

  const searchBox = document.querySelector(".search-box");
  const options1 = document.querySelectorAll(".options li");
  const selectedOption = document.querySelector(".selected-option");
  const clearButton = document.getElementById("clear-button");

  // Check if search country present in menu list
  // searchBox.addEventListener('input', () => {
  //   const searchTerm = searchBox.value.toLowerCase();

  //   options.forEach(option => {
  //     const text = option.textContent.toLowerCase();
  //     if (text.includes(searchTerm)) {
  //       option.style.display = 'block';
  //     } else {
  //       option.style.display = 'none';
  //     }
  //   });
  // });

  // const _SEARCH = (e) => {
  //   setAdminSupplierData({})
  //   const searchTerm = e.target.value?.toLowerCase();

  //   options1.forEach(option => {
  //     const text = option.textContent?.toLowerCase();

  //     if (text.includes(searchTerm)) {
  //       option.style.display = 'block';
  //     } else {
  //       option.style.display = 'none';
  //     }
  //   });
  // }
  // console.log(options1)
  //   // Iterating and printing the selected country name
  //   for (const option of options1) {
  //     console.log(option)
  //     // option.addEventListener('click', () => {
  //     //   const value = option.getAttribute('data-value');
  //     //   selectedOption.textContent =
  //     //     "You have chosen " + option.textContent;
  //     //   searchBox.value = '';
  //     //   for (const opt of options) {
  //     //     opt.style.display = 'block';
  //     //   }
  //     // });
  //   }

  const _SELECT_SUPPLIER = (data) => {
    setIsLoading(true);
    setStateData(
      State.getStatesOfCountry(getCode(JSON.parse(data.value).country))
    );
    setCityData(
      City.getCitiesOfState(
        getCode(JSON.parse(data.value).country),
        JSON.parse(data.value)?.state?.toUpperCase(),
        JSON.parse(data.value)?.state?.toUpperCase()
      )
    );
    setAdminSupplierData(JSON.parse(data.value));
    setCountry(getCode(JSON.parse(data.value).country));
    setState(JSON.parse(data.value).state);
    setCity(JSON.parse(data.value).city);
    setIsLoading(false);
  };

  function titleCase(str) {
    str = str?.toLowerCase()?.split(" ");
    for (var i = 0; i < str?.length; i++) {
      str[i] = str[i]?.charAt(0)?.toUpperCase() + str[i]?.slice(1);
    }
    return str?.join(" ");
  }

  const _SET_EXISTING = (data) => {
    setIsLoading(true);
    setExistingOrNew(data);
    if (data === "new") {
      setAdminSupplierData({});
      setCountry("");
      setState("");
      setCity("");
      setIsLoading(false);
    }
    if (data === "own") {
      const logalData = JSON.parse(localStorage.getItem("gs3_User"));
      // console.log(logalData);
      const setData = {
        name: JSON.parse(localStorage.getItem("gs3_User")).companyName,
        mobile: JSON.parse(localStorage.getItem("gs3_User")).phone,
        email: JSON.parse(localStorage.getItem("gs3_User")).email,
        website: JSON.parse(localStorage.getItem("gs3_User")).companyWebsiteUrl,
        address: JSON.parse(localStorage.getItem("gs3_User")).address,
        country: JSON.parse(localStorage.getItem("gs3_User")).country,
        state: JSON.parse(localStorage.getItem("gs3_User")).state,
        city: JSON.parse(localStorage.getItem("gs3_User")).city,
        zipcode: JSON.parse(localStorage.getItem("gs3_User")).zipcode,
      };
      setAdminSupplierData(setData);
      setCity(JSON.parse(localStorage.getItem("gs3_User"))?.city);
      onCountry(JSON.parse(localStorage.getItem("gs3_User"))?.country);
      onState(JSON.parse(localStorage.getItem("gs3_User"))?.state);

      // setStateData(
      //   State.getStatesOfCountry(
      //     getCode(
      //       titleCase(JSON.parse(localStorage.getItem("gs3_User")).countryCode)
      //     )
      //   )
      // );
      // setCityData(
      //   City.getCitiesOfState(
      //     getCode(JSON.parse(localStorage.getItem("gs3_User")).countryCode),
      //     JSON.parse(
      //       localStorage.getItem("gs3_User")
      //     )?.stateCode?.toUpperCase(),
      //     JSON.parse(localStorage.getItem("gs3_User"))?.stateCode?.toUpperCase()
      //   )
      // );
      // setAdminSupplierData(JSON.parse(localStorage.getItem('gs3_User')))
      // setCountry(
      //   titleCase(getCode(JSON.parse(localStorage.getItem("gs3_User")).country))
      // );
      // setState(JSON.parse(localStorage.getItem("gs3_User")).state);
      setCity(JSON.parse(localStorage.getItem("gs3_User")).city);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain suppliersBg">
        <Leftpanel breadcm="Supplier" />
        <div className="dbRight">
          <Header
            link="/suppliers"
            breadcm=""
            title={t("Add Suppliers")}
            description=""
          />
          {isLoading && <SpinnerComponent isLoading={isLoading} />}
          <div className="commonBase">
            <Form id="form-Data" onSubmit={_ON_SUBMIT}>
              <label className="mb-2">Contact Details</label>
              {/* <Form.Group className="row" >
                <Col md="6" className='mb-3'></Col>
                <Col md="6" className='mb-3'></Col>
              </Form.Group> */}

              <Form.Group className="row">
                <Col md="6" className="mb-3">
                  <div className="supplName mb-1">
                    <label htmlFor="SupplierName">{t("supplier_name")}</label>
                    <div className="supplRadio">
                      <span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-existing">
                              {t(
                                "Supplier already registered in VIRIDI Business Central web"
                              )}
                            </Tooltip>
                          }
                        >
                          <label htmlFor="existing">
                            <input
                              type="radio"
                              name="supplierName"
                              id="existing"
                              defaultChecked={existingOrNew === "existing"}
                              onChange={() => _SET_EXISTING("existing")}
                            />
                            {t("existing")}
                          </label>
                        </OverlayTrigger>
                      </span>
                      <span>
                        <label htmlFor="new">
                          <input
                            type="radio"
                            name="supplierName"
                            id="new"
                            defaultChecked={existingOrNew === "new"}
                            onChange={() => _SET_EXISTING("new")}
                          />
                          {t("new")}
                        </label>
                      </span>
                      <span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-own">
                              {t("Create the company as a supplier")}
                            </Tooltip>
                          }
                        >
                          <label htmlFor="own">
                            <input
                              type="radio"
                              name="supplierName"
                              id="own"
                              defaultChecked={existingOrNew === "own"}
                              onChange={() => _SET_EXISTING("own")}
                            />
                            {t("own")}
                          </label>
                        </OverlayTrigger>
                      </span>
                    </div>
                  </div>

                  {existingOrNew === "existing" ? (
                    <Select
                      options={listSearchSupplier}
                      placeholder={t("search_supplier_name")}
                      onChange={_SELECT_SUPPLIER}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder={t("supplier_name")}
                      id="SupplierName"
                      name="name"
                      defaultValue={adminSupplierData?.name}
                      onChange={(e) =>
                        setAdminSupplierData({
                          ...adminSupplierData,
                          name: e.target.value,
                        })
                      }
                    />
                  )}
                </Col>

                <Col md="6" className="mb-3">
                  <label htmlFor="SupplierCompanyId" className="pb-1">
                    {t("supplier_company_id")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("supplier_company_id")}
                    id="SupplierCompanyId"
                    name="supplierCompanyId"
                    defaultValue={adminSupplierData?.supplierCompanyId}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        supplierCompanyId: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <Form.Group className="row">
                <Col md="6" className="mb-3">
                  <label htmlFor="mobile">{t("contact_number")}</label>
                  <Form.Control
                    type="text"
                    placeholder={t("contact_number")}
                    name="mobile"
                    id="mobile"
                    defaultValue={adminSupplierData?.mobile}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        mobile: e.target.value,
                      })
                    }
                  />
                </Col>
                <Col md="6" className="mb-3">
                  <label htmlFor="email">{t("email")}</label>
                  <div className="d-flex">
                    <Form.Control
                      type="email"
                      id="email"
                      placeholder={t("email")}
                      name="email"
                      defaultValue={adminSupplierData?.email}
                      onChange={(e) =>
                        setAdminSupplierData({
                          ...adminSupplierData,
                          email: e.target.value,
                        })
                      }
                    />
                  </div>
                </Col>
              </Form.Group>

              <Form.Group className="row">
                <Col md="6" className="mb-3">
                  <label htmlFor="Country">{t("country")}</label>
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                    id="Country"
                    onChange={(e) => onCountry(e.target.value)}
                  >
                    <option value="">{t("select_country")}</option>
                    <option selected hidden>
                      {t("select_country")}
                    </option>
                    {countryData.map((con) => (
                      <option
                        value={con.countryCode}
                        selected={con.countryCode === country}
                        key={con.countryCode}
                      >
                        {con.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md="6" className="mb-3">
                  <label htmlFor="zipCode">{t("zip_code")}</label>
                  <Form.Control
                    type="text"
                    placeholder={t("zip_code")}
                    id="zipCode"
                    name="zipcode"
                    defaultValue={adminSupplierData?.zipcode}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        zipCode: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <Form.Group className="row">
                <Col md="6" className="mb-3">
                  <label htmlFor="state">{t("state")}</label>
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                    id="state"
                    onChange={(e) => onState(e.target.value)}
                  >
                    <option selected hidden>
                      {t("select_state")}
                    </option>
                    {stateData.map((sta) => (
                      <option
                        value={sta.isoCode}
                        selected={sta.isoCode === state}
                        key={sta.isoCode}
                      >
                        {sta.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <Col md="6" className="mb-3">
                  <label htmlFor="city">{t("city")}</label>
                  <Form.Select
                    className="form-control"
                    aria-label="Default select example"
                    id="city"
                    onChange={onCity}
                  >
                    <option selected hidden>
                      {t("select_city")}
                    </option>
                    {cityData.map((cit) => (
                      <option
                        value={cit.name}
                        selected={cit?.name === city}
                        key={cit.name}
                      >
                        {cit.name}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Form.Group>

              <Form.Group className="mb-3 row">
                <Col md="12" className="mb-3">
                  <label htmlFor="address">{t("address")}</label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder={t("address")}
                    name="address"
                    id="address"
                    defaultValue={adminSupplierData?.address || ""}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        address: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <Form.Group className="mb-3 row">
                <Col className="col-md-6">
                  <label htmlFor="website">{t("website")}</label>
                  <Form.Control
                    type="text"
                    placeholder={t("add_website_url")}
                    name="website"
                    id="website"
                    defaultValue={adminSupplierData?.website}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        website: e.target.value,
                      })
                    }
                  />
                </Col>

                <Col className="col-md-6">
                  <label htmlFor="industry">{t("industry")}</label>
                  <Form.Control
                    type="text"
                    placeholder={t("add_industry")}
                    id="industry"
                    name="industry"
                    defaultValue={adminSupplierData?.industry}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        industry: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <Form.Group className="mb-3 row">
                <Col className="col-md-12">
                  <label htmlFor="currencyType">{t("currency")}</label>
                  <Form.Select
                    name="currencyType"
                    id="currencyType"
                    className="form-control"
                    aria-label="Default select example"
                  >
                    <option value="">{t("select_currency")}</option>
                    {currency.length > 0 &&
                      currency.map((item, index) => (
                        <option
                          value={item.name}
                          key={index}
                          selected={
                            adminSupplierData.currencyType === item.name
                          }
                        >
                          {item.name}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
              </Form.Group>

              {/* <div className="toggle-container addToggle mb-4 mt-4">
                                <p>Invoice from exchange service:</p>
                                <label className="switch">
                                    <input type="checkbox" checked={isToggleddata} onChange={handleToggledata} />
                                    <span className="slider round"></span>
                                </label>
                                <span>{isToggleddata ? 'On' : 'Off'}</span>
                            </div> */}

              {/* <label className='mb-2'>Industry sectors</label>
                            <Form.Group className="mb-3 row" controlId="exampleForm.ControlInput1">
                                <Col className='col-md-12'><Form.Control type="text" placeholder="Industry Sectors" /></Col>
                            </Form.Group> */}
              <h6 className="pt-3">
                <label className="mb-2">{t("contact_persons")}</label>
              </h6>
              <label className="mb-2">{t("products")}:</label>
              <Form.Group className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonProductName">
                    {t("contact_person_product_name")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("name")}
                    name="ContactPersonProductName"
                    id="ContactPersonProductName"
                    defaultValue={adminSupplierData?.ContactPersonProductName}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonProductName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonProductEmail">
                    {t("contact_person_product_email")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("email_id")}
                    id="ContactPersonProductEmail"
                    name="ContactPersonProductEmail"
                    defaultValue={adminSupplierData?.ContactPersonProductEmail}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonProductEmail: e.target.value,
                      })
                    }
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3 row">
                <Col className="col-md-6">
                  <label htmlFor="ContactPersonProductPhone">
                    {t("contact_person_product_phone")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("contact_number")}
                    name="ContactPersonProductPhone"
                    defaultValue={adminSupplierData?.ContactPersonProductPhone}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonProductPhone: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <label className="mb-2">{t("orders")}:</label>
              <Form.Group className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonOrderName">
                    {t("contact_person_order_name")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("name")}
                    name="ContactPersonOrderName"
                    id="ContactPersonOrderName"
                    defaultValue={adminSupplierData?.ContactPersonOrderName}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonOrderName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonOrderEmail">
                    {t("contact_person_order_email")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("email_id")}
                    name="ContactPersonOrderEmail"
                    defaultValue={adminSupplierData?.ContactPersonOrderEmail}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonOrderEmail: e.target.value,
                      })
                    }
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3 row">
                <Col className="col-md-6">
                  <label htmlFor="ContactPersonOrderPhone">
                    {t("contact_person_order_phone")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("contact_number")}
                    name="ContactPersonOrderPhone"
                    defaultValue={adminSupplierData?.ContactPersonOrderPhone}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonOrderPhone: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <label className="mb-2">{t("invoices")}:</label>
              <Form.Group className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonInvoiceName">
                    {t("contact_person_invoice_name")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("name")}
                    name="ContactPersonInvoiceName"
                    id="ContactPersonInvoiceName"
                    defaultValue={adminSupplierData?.ContactPersonInvoiceName}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonInvoiceName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonInvoiceEmail">
                    {t("contact_person_invoice_email")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("email_id")}
                    name="ContactPersonInvoiceEmail"
                    id="ContactPersonInvoiceEmail"
                    defaultValue={adminSupplierData?.ContactPersonInvoiceEmail}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonInvoiceEmail: e.target.value,
                      })
                    }
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3 row">
                <Col className="col-md-6">
                  <label htmlFor="ContactPersonInvoicePhone">
                    {t("contact_person_invoice_phone")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("contact_number")}
                    name="ContactPersonInvoicePhone"
                    defaultValue={adminSupplierData?.ContactPersonInvoicePhone}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonInvoicePhone: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              <label className="mb-2">{t("quality_issues")}:</label>
              <Form.Group className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonQualityName">
                    {t("contact_person_quality_name")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("name")}
                    name="ContactPersonQualityName"
                    id="ContactPersonQualityName"
                    defaultValue={adminSupplierData?.ContactPersonQualityName}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonQualityName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="ContactPersonQualityEmail">
                    {t("contact_person_quality_email")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("email_id")}
                    name="ContactPersonQualityEmail"
                    id="ContactPersonQualityEmail"
                    defaultValue={adminSupplierData?.ContactPersonQualityEmail}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonQualityEmail: e.target.value,
                      })
                    }
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3 row">
                <Col className="col-md-6">
                  <label htmlFor="ContactPersonQualityPhone">
                    {t("contact_person_quality_phone")}
                  </label>
                  <Form.Control
                    type="text"
                    placeholder={t("contact_number")}
                    name="ContactPersonQualityPhone"
                    defaultValue={adminSupplierData?.ContactPersonQualityPhone}
                    onChange={(e) =>
                      setAdminSupplierData({
                        ...adminSupplierData,
                        ContactPersonQualityPhone: e.target.value,
                      })
                    }
                  />
                </Col>
              </Form.Group>

              {/* <label className='mb-2'>Suppliers certifications</label>
                            <Form.Group className="mb-3 row" controlId="exampleForm.ControlInput1">
                                <Col className='col-md-12 uploadMultifile'>
                           
                                    <Form.Control type="file" placeholder="Upload certificates" onChange={handleFileChange} accept="image/*" />

                                    <div className='browseBase'>
                                        {images.map((image, index) => (
                                            <div key={index} className='browsefileblock'>
                                                <img
                                                    src={URL.createObjectURL(image)}
                                                    alt={`Preview-${index}`}
                                                    style={{ width: '100px', height: 'auto' }}
                                                />
                                                <button onClick={() => handleRemoveImage(index)}><i className="fa-solid fa-circle-xmark"></i></button>
                                            </div>
                                        ))}
                                    </div>
                                </Col>







                            </Form.Group> */}

              {/* <label className='mb-2'>Currency</label>
                            <Form.Group className="row" controlId="exampleForm.ControlInput1">
                                <Col sm="12" className='mb-3'>
                                    <Form.Select className='form-control' aria-label="Default select example">
                                        <option>Select Currency</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </Form.Select>
                                </Col>
                            </Form.Group> */}
              <label className="mb-2">{t("Total Employee")}</label>
              <Form.Group className="row">
                <Col sm="12" className="mb-3">
                  <Form.Group className="row">
                    <div className="col-md-12 mb-3">
                      <Form.Control
                        type="text"
                        placeholder={t("total_employee")}
                        name="totalEmployee"
                        defaultValue={adminSupplierData?.totalEmployee}
                        onChange={(e) =>
                          setAdminSupplierData({
                            ...adminSupplierData,
                            totalEmployee: e.target.value,
                          })
                        }
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Form.Group>

              <Form.Group className="mb-4">
                <div className="multiSlct mls">
                  <label className="mb-2">{t("add_unspsc")}</label>
                  <Form.Group className="mb-3 row">
                    <Col className="col-md-12">
                      <Form.Control
                        type="text"
                        placeholder={t("select_unspsc")}
                        name="unspscCode"
                        onClick={(e) => onUnspc(e)}
                        defaultValue={adminSupplierData?.unspscCode}
                        onChange={(e) =>
                          setAdminSupplierData({
                            ...adminSupplierData,
                            unspscCode: e.target.value,
                          })
                        }
                      />
                    </Col>
                  </Form.Group>
                </div>
              </Form.Group>

              {/* <Form.Group className="row">
                <Col sm="3" className="mb-3">
                  <label className="mb-2">
                    <input
                      type="radio"
                      checked={saleChecked}
                      onClick={() => setSaleChecked((prev) => !prev)}
                    />
                    &nbsp; {t("Sale Unit")}
                  </label>
                  <Form.Group className="row">
                    <div className="col-md-12 mb-3">
                      <Select
                        isDisabled={!saleChecked}
                        isMulti
                        options={units}
                        value={saleUnit}
                        onChange={onSaleUnit}
                        placeholder={t("select")}
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col sm="3" className="mb-3">
                  <label className="mb-2">
                    <input
                      type="radio"
                      checked={baseChecked}
                      onClick={() => setBaseChecked((prev) => !prev)}
                    />
                    &nbsp; {t("Base Unit")}
                  </label>
                  <Form.Group className="row">
                    <div className="col-md-12 mb-3">
                      <Select
                        isDisabled={!baseChecked}
                        isMulti
                        options={units}
                        value={baseUnit}
                        onChange={onBaseUnit}
                        placeholder={t("select")}
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col sm="3" className="mb-3">
                  <label className="mb-2">
                    <input
                      type="radio"
                      checked={subChecked}
                      onClick={() => setSubChecked((prev) => !prev)}
                    />
                    &nbsp; {t("Sub Unit")}
                  </label>
                  <Form.Group className="row">
                    <div className="col-md-12 mb-3">
                      <Select
                        isDisabled={!subChecked}
                        isMulti
                        options={units}
                        value={subUnit}
                        onChange={onSubUnit}
                        placeholder={t("select")}
                      />
                    </div>
                  </Form.Group>
                </Col>

                <Col sm="3" className="mb-3">
                  <label className="mb-2">
                    <input
                      type="radio"
                      checked={co2Checked}
                      onClick={() => setCo2Checked((prev) => !prev)}
                    />
                    &nbsp; {t("CO2 Unit")}
                  </label>
                  <Form.Group className="row">
                    <div className="col-md-12 mb-3">
                      <Select
                        isDisabled={!co2Checked}
                        isMulti
                        options={units}
                        value={co2Unit}
                        placeholder={t("select")}
                        onChange={onCO2Unit}
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Form.Group> */}

              <div className="commonBase mb-4" style={{ padding: "0px" }}>
                <h6 className="mb-3">{t("add") + " " + t("GHG Key")}</h6>

                <div className="additembox groupBordr">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      style={{ height: "100%" }}
                    >
                      {ghgData
                        ? JSON.parse(ghgData)?.key
                        : `${t("select")} ${t("GHG Key")}`}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                      }}
                    >
                      {sortedData?.map((con) => (
                        <OverlayTrigger
                          key={con.id}
                          placement="top"
                          overlay={
                            <Tooltip
                              id={`tooltip-${con.id}`}
                              style={{ fontSize: "18px" }}
                            >
                              {con?.value}
                            </Tooltip>
                          }
                        >
                          <Dropdown.Item
                            as="button"
                            style={{ height: "100%" }}
                            onClick={(event) => {
                              event.preventDefault();
                              setGhgData(JSON.stringify(con));
                            }}
                          >
                            {`(${con.key})`}
                          </Dropdown.Item>
                        </OverlayTrigger>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t("add") + " " + t("GHG Key")}
                    value={ghgData ? JSON.parse(ghgData)?.value : ""}
                    disabled
                  />
                </div>
              </div>

              <button className="commonButton" type="submit">
                {t("add_now")}
              </button>
            </Form>
          </div>
        </div>
      </div>

      <Modal size="lg" show={showUnspc} onHide={handleCloseUnspc} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5 className="mb-0">{t("add")} UNSPSC</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="dbMaintable productMainScroll">
            {/* <input type="text" className="form-control mb-2" placeholder="Search UNSPSC..." onChange={_SEARCH_UNSPSC} /> */}
            <Select
              options={searchOptions}
              // onChange={_GET_CLASS_DATA}
              placeholder={`Search UNSPSC...`}
              // isDisabled={familyData.value}
              noOptionsMessage={() => "Type something UNSPSC specific"}
              onChange={_SELECT_UNSPSC}
              onInputChange={_SEARCH_UNSPSC}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
            />
            <h2 className="d-flex justify-content-center">{t("OR")}</h2>

            <h5 className="mt-4 mb-3">UNSPSC :</h5>
            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                {segmentDataList
                  .sort((a, b) => a?.Segment - b?.Segment)
                  ?.map((segment) => (
                    <TreeItem
                      key={segment.Segment}
                      title={t("segment_code", {
                        segment: segment.Segment,
                        title: segment.SegmentTitle,
                      })} // Use translation
                      isOpen={openSegment === segment.Segment}
                      toggleOpen={() => handleSegmentClick(segment.Segment)}
                      onClick={onDataSegment.bind(
                        segment?.Segment,
                        `${segment?.Segment}`
                      )}
                    >
                      {allUnspcFamily?.map((family) => (
                        <TreeItem
                          key={family.Family}
                          title={t("family_code", {
                            family: family.Family,
                            title: family.FamilyTitle,
                          })} // Use translation
                          isOpen={openFamily === family.Family}
                          toggleOpen={() =>
                            handleFamilyClick(segment.Segment, family.Family)
                          }
                          onClick={onDataFamily.bind(
                            family?.Family,
                            `${family?.Family}`
                          )}
                        >
                          {allUnspcClass?.map((classItem) => (
                            <TreeItem
                              key={classItem.Class}
                              title={t("class_code", {
                                class: classItem.Class,
                                title: classItem.ClassTitle,
                              })} // Use translation
                              isOpen={openClass === classItem.Class}
                              toggleOpen={() =>
                                handleClassClick(family.Family, classItem.Class)
                              }
                              onClick={onDataClass.bind(
                                classItem?.Class,
                                `${classItem?.Class}`
                              )}
                            >
                              {allUnspcComodity?.map((commodity) => (
                                <TreeItem
                                  key={commodity.Commodity}
                                  title={t("commodity_code", {
                                    commodity: commodity.Commodity,
                                    title: commodity.CommodityTitle,
                                  })} // Use translation
                                />
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                    </TreeItem>
                  ))}
              </div>
            </div>

            {/* <>
              <label htmlFor="">Segment</label>
              <Select
                options={allUnspcList}
                onChange={_GET_FAMILY_DATA}
                placeholder={"Search segment..."}
                isDisabled={segmentData.value}
                noOptionsMessage={()=>'You do not have any segment. Please add from configuration.'}
              />
              <input
                type="text"
                className="form-control addUnspc mb-3 mt-1"
                value={segmentData.value}
                placeholder="Segment Code"
                readOnly
              />
            </>
            {segmentData.value && (
              <>
                <label htmlFor="">Family</label>
                <Select
                  options={familyList}
                  onChange={_GET_CLASS_DATA}
                  placeholder={"Search family..."}
                  isDisabled={familyData.value}
                  noOptionsMessage={()=>'You do not have any segment. Please add from configuration.'}
                />
                <input
                  type="text"
                  className="form-control addUnspc mb-3 mt-1"
                  value={familyData.value}
                  placeholder="Family Code"
                  readOnly
                />
              </>
            )}
            {familyData.value && (
              <>
                <label htmlFor="">Class</label>
                <Select
                  options={classList}
                  onChange={_GET_COMMODITY_DATA}
                  placeholder={"Search Class..."}
                  isDisabled={classData.value}
                  noOptionsMessage={()=>'You do not have any segment. Please add from configuration.'}
                />
                <input
                  type="text"
                  className="form-control addUnspc mb-3 mt-1"
                  value={classData.value}
                  placeholder="Class Code"
                  readOnly
                />
              </>
            )}
            {classData.value && (
              <>
                <label htmlFor="">Commodity</label>
                <Select
                  options={commodityList}
                  onChange={_SET_FINAL_DATA}
                  placeholder={"Search Commodity..."}
                  // isDisabled={commodityData.value}
                  noOptionsMessage={()=>'You do not have any segment. Please add from configuration.'}
                />
                <input
                  type="text"
                  className="form-control addUnspc mb-3 mt-1"
                  value={commodityData.value}
                  placeholder="Class Code"
                  readOnly
                />
              </>
            )} */}
          </div>

          <div className="d-flex">
            {/* <button className="commonButton mr-2 p-2" onClick={(e) => onAddUnspc(e)}>
              Add
            </button>
            &nbsp;
            {segmentData.value && (
              <button className="commonButton p-2" onClick={(e) => onRemoveUnspc(e)}>
                Previous
              </button>

            )} */}
            <button className="commonButton ms-auto p-2" onClick={searchPage}>
              {t("View More")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Addsuppliers;
